import { useSetupFooter } from "views/Setup/context/SetupFooterContext";
import { useFeatureEffects } from "../../hooks/useFeatureEffects";
import { useFeaturesForm } from "../../hooks/useFeaturesForm";
import useFooterStore from "views/hooks/useFooterStore";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import FeaturesForm from "./FeaturesForm";
import Loading from "components/Loading";
import { Form } from "antd";
import React from "react";

interface FeaturesProps {
  nextButton?: () => void;
  prevButton?: () => void;
  isSetup?: boolean;
  loading?: boolean;
}

export default function Features({
  nextButton,
  isSetup,
  loading,
}: FeaturesProps): React.ReactElement {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const tabName = pathname.split("/").pop();
  const saveLoading = useFooterStore(state => state.saveLoading);

  const { handleFormSubmit, handleSaveClick, invoiceTypeOptions } = useFeaturesForm({
    form,
    nextButton,
    t,
  });

  useFeatureEffects({ form, tabName, isSetup, handleSaveClick });

  useSetupFooter(isSetup ? { onSave: handleSaveClick, loading } : null);

  return (
    <>
      {loading || saveLoading ? (
        <Loading />
      ) : (
        <FeaturesForm
          form={form}
          onFinish={handleFormSubmit}
          invoiceTypeOptions={invoiceTypeOptions}
        />
      )}
    </>
  );
}
